import MarketingCopy from './MarketingCopy';

export default MarketingCopy;
